import { useCallback, useRef } from 'react';

const useScrollIntoView = () => {
  const ref = useRef(null);
  const scroll = useCallback((scrollParams = {}) => {
    const { scrollOnce } = scrollParams;
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        ...scrollParams
      });
      if (scrollOnce) {
        ref.current = null;
      }
    }
  }, []);
  return { ref, scroll };
};

export default useScrollIntoView;
